import { Switch as SwitchAdminUI } from '@vtex/admin-ui';
import { useSwitch } from './use-switch.hook';
import styles from './style.module.css';

export type SwitchProps = {
  value?: boolean;
  disabled?: boolean;
  onSwitch?: (value: boolean) => void;
};

export const Switch = (props: SwitchProps) => {
  const { switchState } = useSwitch({ ...props });

  return (
    <div className={styles.switchContainer}>
      <SwitchAdminUI disabled={props.disabled} state={switchState} label="" />
    </div>
  );
};
